module.exports = __webpack_public_path__ + "static/media/2playerRoomsPlayed_50_100.b91c2223.png";